<template>
  <card body-classes="px-0 pb-1" class="no-border-card" footer-classes="pb-2">
    <template slot="header">
      <h3 class="mb-0">Tipos de conceptos de pago</h3>
    </template>

    <div>
      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <el-select v-model="pagination.perPage" class="select-primary pagination-select" placeholder="Per page">
          <el-option
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
            class="select-primary"
          >
          </el-option>
        </el-select>
        <div>
          <base-input v-model="mixSearchQuery" placeholder="Buscar..." prepend-icon="fas fa-search"> </base-input>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <el-table :data="tableData" header-row-class-name="thead-light" row-key="id" @sort-change="sortChange">
        <el-table-column label="Descripción" min-width="180px" prop="description" sortable />
        <el-table-column align="right" label="" min-width="120px">
          <div slot-scope="{ row }" class="d-flex">
            <router-link
              v-if="$can('update', 'concept_payment_types')"
              :to="{ name: 'ConceptPaymentTypeEdit', params: { id: row.id } }"
              class="btn btn-outline-primary btn-sm"
            >
              <i class="fas fa-pen"></i>
            </router-link>
            <button
              v-if="$can('destroy', 'concept_payment_types')"
              class="btn base-button btn-outline-danger btn-sm"
              @click="deleteRow(row.id)"
            >
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <div class="">
        <p class="card-category">
          Mostrando {{ from + 1 }} a {{ to }} de un total de {{ pagination.total }} tipos de concepto de pago
        </p>
      </div>
      <base-pagination
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="pagination.total"
        class="pagination-no-border"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import { BasePagination } from '@/components';
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui';
import PaginationOnServerMixin from '@/mixins/paginationOnServerMixin';
import DeleteRowFromTableMixin from '@/mixins/deleteRowFromTableMixin';

export default {
  name: 'ConceptPaymentTypesTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
  },

  mixins: [PaginationOnServerMixin, DeleteRowFromTableMixin],
  data() {
    return {
      searchKeys: ['description'],
      tableData: [],
      modelName: 'conceptPaymentType',
    };
  },

  created() {
    this.fetchTableData();
    this.resourceName = 'concept_payment_types';
  },

  methods: {
    fetchTableData() {
      this.pagination.perPage = this.perPage || this.pagination.perPage;
      this.pagination.currentPage = this.page || this.pagination.currentPage;
      const params = {
        'filter[search]': this.mixSearchQuery,
        perPage: this.pagination.perPage,
        page: this.pagination.currentPage,
        sort: this.sort || this.defaultSort,
      };

      this.$services
        .resource('concept_payment_types')
        .get(params)
        .then((res) => {
          this.setMeta(res.data.meta);
          return res.data.data;
        })
        .then(({ conceptPaymentTypes }) => {
          this.tableData = conceptPaymentTypes;
        });
    },
  },
};
</script>

<style scoped>
::v-deep .el-table__expand-column .cell {
  width: 20px;
}

::v-deep .el-table__expanded-cell p {
  word-break: break-word;
  white-space: normal;
}
</style>
